<template>
  <div class="start-container" ref="startRef">
    <frame-animation v-if="isShow" :urlRoot="`matr1xFireIntro/animate/start${isMobile ? '_m' : ''}/`" :canPlay="isShow && canPlay"
      :indexRange="[1, 10]" :speed="120" :loop="false" @finallyOver="finallyOver" />
  </div>
</template>

<script>
import FrameAnimation from "@/components/frameAnimation";
import responsiveMixin from "@/mixins/responsive";

export default {
  mixins: [responsiveMixin],
  components: { FrameAnimation },
  data() {
    return {
      isShow: true,
      timer: null
    };
  },
  props: {
    canPlay: {
      type: Boolean,
      default: false
    }
  },
  mounted() { },
  methods: {
    finallyOver() {
      this.timer = setTimeout(() => {
        this.isShow = false;
        this.$emit("finish")
      }, 400)
    }
  },
  beforeDestroy() {
    this.timer && clearTimeout(this.timer);
  },
  watch: {
    canPlay: {
      handler(newValue) {
        this.isShow = newValue;
      },
      immediate: true
    }
  }
};
</script>

<style lang="scss" scoped>
@import "./index.scss";
</style>